import { queryPageMemberGroupApi } from '@eastcoal/api/auth/group/queryPageMemberGroup'
import { MemberGroupEntity } from '@eastcoal/api/auth/interface'

import { RemoteSelect } from '@eastcoal/common/components/RemoteSelect'
import { pick } from '@eastcoal/common/utils/object'

import { useCustomMemberGroupStore } from '../Store/hooks'

const resolveOptions = (value?: MemberGroupEntity[]) =>
  value?.map(item => ({
    label: item.groupName,
    value: item?.id
  }))

const getOptionValue = (value: MemberGroupEntity) => `${value.id}`

export const BuiltinGroupSelect = () => {
  const { value, onChange, disabled } = useCustomMemberGroupStore(state =>
    pick(state, ['value', 'onChange', 'disabled'])
  )

  return (
    <RemoteSelect
      allowClear
      api={queryPageMemberGroupApi}
      disabled={disabled}
      getOptionValue={getOptionValue}
      mode='multiple'
      resolveOptions={resolveOptions}
      value={value}
      onChange={onChange}
    />
  )
}
